import "../css/Inicio.css";
import Navbar1 from "../components/Navbar1";
import Navbar2 from "../components/Navbar2";
import Panel_Miembros from "../components/Panel_Miembros";
import Footer from "../components/Footer";

export default function Quienes_somos() {
  return (
    <div className="Quienes_somos">
      <Navbar1 />
      <Navbar2 />
      <Panel_Miembros />
      <Footer />
    </div>
  );
}
